// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1nuDs","inner":"Footer_inner__3Fwe3"};